import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-narrow-left', 'ArrowNarrowLeft', [["path",{"d":"M5 12l14 0"}],["path",{"d":"M5 12l4 4"}],["path",{"d":"M5 12l4 -4"}]]);